import React from 'react'

const FollowedEvents = () => {
  return (
    <><h2>Followed</h2><h3>Refresh me, and you will still be on this page.</h3></>
  )
}

export default FollowedEvents